import { Tag } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  active: boolean;
};

const CompanyActiveTag: React.FC<Props> = ({ active }) => {
  const { t: tCommon } = useTranslation();
  const type = active ? ('success' as const) : ('neutral' as const);

  return <Tag data-color={type}>{active ? tCommon('active') : tCommon('inactive')}</Tag>;
};

export default CompanyActiveTag;
